"use client"

import React, { useEffect, useState } from "react"
import { Drawer } from "@mui/material"
import { inrFormat } from "@common/utils/formatCurrency"
import CartDrawerTabs from "../CartDrawerTabs"
import { useLocation, useNavigate } from "react-router-dom"

import { useAppDispatch, useAppSelector } from "../../../store/hooks"
import { fetchCart, selectCartItems, selectCartPrice, selectCartLoading } from "../../../store/slices/cartSlice"
import { fetchWishlist, selectWishlistItems, selectWishlistLoading } from "../../../store/slices/wishlistSlice"

function CartDrawer() {
  const navigate = useNavigate()
  const location = useLocation(); // Hook to detect route changes
  const [state, setState] = React.useState({
    right: false,
  })
  const [tabVariant, setTabVariant] = useState("cart")

  const toggleDrawer = (anchor, open) => (event) => {
    // Preventing drawer toggle with Tab or Shift key press
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return
    }

    setState({ ...state, [anchor]: open })
  }

  // Function far cart
  // get cart details
  const dispatch = useAppDispatch()
  const cartItems = useAppSelector(selectCartItems)
  const cartPrice = useAppSelector(selectCartPrice)
  const cartLoading = useAppSelector(selectCartLoading)
  const wishlistItems = useAppSelector(selectWishlistItems)
  const wishlistLoading = useAppSelector(selectWishlistLoading)

  useEffect(() => {
    if (state.right) {
      dispatch(fetchCart())
      dispatch(fetchWishlist())
    }
  }, [state.right, dispatch])

  const handleProceed = () => {
    // Handle the proceed action here
    // For example, navigate to the checkout page
    setState({ ...state, right: false })
    navigate("/cart")
  }

  // Close the drawer on route change
  useEffect(() => {
    if (state.right) {
      setState({ ...state, right: false });
    }
  }, [location]); // Triggered whenever the route changes

  const getCartQuantity = (cartItems) => {
    if (!cartItems) return 0
    const cartQuantity = cartItems.reduce((acc, item) => acc + item.quantity, 0)
    return cartQuantity
  }

  // console.log('wishListData?.wishlist', wishListData?.wishList);
  return (
    <>
      <div className="mod-cart-btn">
        <button className="bs-btn bs-btn__btn-icon bs-header__action mod-cart-btn__action" onClick={toggleDrawer("right", true)}>
          <span className="icon icon-cart"></span>
        </button>
        {cartItems?.length > 0 ? (<span className="mod-cart-btn__count">{getCartQuantity(cartItems)}</span>) : null}
        {console.log('cartItems', cartItems)}
      </div>

      <Drawer
        anchor="right"
        open={state.right}
        onClose={toggleDrawer("right", false)}
        className="bs-drawer bs-drawer--typ-cart"
      >
        <button className="bs-btn bs-btn__btn-icon bs-drawer__close-btn" onClick={toggleDrawer("right", false)}>
          <span className="icon icon-close"></span>
        </button>
        <div className="bs-drawer__cont-wrap">
          <CartDrawerTabs cartData={cartItems} wishlistData={wishlistItems} setTabVariant={setTabVariant} />
        </div>
        {cartItems?.length > 0 && tabVariant === "cart" && (
          <div className="bs-drawer__foot-wrap">
            <div className="bs-drawer__amount-wrap">
              <strong className="bs-drawer__amount-wrap-title">total amount</strong>
              <div className="bs-drawer__price-wrap">
                <p className="bs-product-tile__price bs-drawer__amount">{inrFormat(cartPrice?.finalPrice)}</p>
                <label className="bs-drawer__amount-info-text">Inclusive of Shipping and Taxes</label>
              </div>
            </div>
            <div className="bs-drawer__action-wrap">
              <button className="bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl" onClick={handleProceed}>
                Proceed
              </button>
            </div>
          </div>
        )}
        {/* <Nodata visible={true}/> */}
      </Drawer>
    </>
  )
}

export default CartDrawer
